import { Theme, css } from '@emotion/react';

import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import Banner, { BannerSize } from '@components/common/Banner';
import Divider from '@components/outlook/Divider';

import { fetchCurrationBanners } from '@api/common';
import { QUERY_KEYS, SectionType } from '@constants';
import { media } from '@styles/css';

const layoutCSS = (theme: Theme) => css`
  margin-top: 112px;

  ${media.tablet} {
    padding: 12px 0;
    background-color: ${theme.var.gray50};
  }
  ${media.desktop} {
    padding: 16px 0;
  }
`;

const HomeBanner = () => {
  const [isVideoLoadEnabled, setIsVideoLoadEnabled] = useState(false);

  const { data: bannerList } = useQuery(
    QUERY_KEYS.BANNER(SectionType.standardRecommend),
    () => fetchCurrationBanners(SectionType.standardRecommend),
    {
      staleTime: 1000 * 60 * 15,
      cacheTime: 1000 * 60 * 15,
      suspense: false,
    }
  );

  useEffect(() => {
    const enableVideoLoad = () => setIsVideoLoadEnabled(true);

    if (document.readyState === 'complete') {
      enableVideoLoad();
      return;
    }

    window.addEventListener('load', enableVideoLoad, { once: true });

    return () => window.removeEventListener('load', enableVideoLoad);
  }, []);

  return (
    <>
      {!!bannerList?.length && (
        <div css={layoutCSS} suppressHydrationWarning={true}>
          <Banner
            name="home-banner"
            size={BannerSize.home}
            items={bannerList}
            isBorder={false}
            priority={true}
            autoPlay
            allowVideo={true}
            videoLoadEnabled={isVideoLoadEnabled}
          />
          <Divider />
        </div>
      )}
    </>
  );
};

export default HomeBanner;
